import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormUtils } from '../utilities/FormUtils/FormUtils';
import { FileService } from '../services/file-service/file.service';
import { MatDatepicker, MatDialog } from '@angular/material';
import { DriverService } from '../services/driver-service/driver.service';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationUrlSettings } from '../settings/ApplicationUrlSettings';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-driver-registration',
  templateUrl: './driver-registration.component.html',
  styleUrls: ['./driver-registration.component.css'],
  host: { 'class': 'driver-registration' }
})
export class DriverRegistrationComponent implements OnInit {
  driverForm: FormGroup;
  licenseForm: FormGroup;
  passwordForm: FormGroup;
  sub = null;
  stepNum = 1;
  stepsTotal = 2;
  emailTaken = false;
  gSignUp = false;
  clientid = null;
  driverid = null;
  access_string = null;
  navOptions = NavBarComponent.standard;
  environment = environment;
  @ViewChild('front') front: ElementRef;
  frontPreview;
  frontFile;
  @ViewChild('dback') dBack: ElementRef;
  backPreview;
  backFile;
  isPasswordVisible: boolean = false;

  myFilter = (d: Date | null): boolean => {    
    return moment(d).isAfter(Date.now());
  };
  
  @ViewChild('picker') picker: MatDatepicker<Date>;
  constructor(private route: ActivatedRoute,private router: Router, private fileService: FileService, private driverService: DriverService, private dialog: MatDialog,    private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.clientid = this.route.snapshot.queryParams.cid;
    this.driverid = this.route.snapshot.queryParams.did;
    this.access_string = this.route.snapshot.queryParams.a;
    if(this.driverid){
      this.driverService.accept(this.driverid,this.clientid,this.access_string).then((res =>{
        new QuickDialog(this.dialog).InfoDialog("The invitation has been accepted. You may now perform jobs on behalf of this company. You driver app has been updated accordingly.","Accepted","OK");
      })).catch(e =>{
        new QuickDialog(this.dialog).InfoDialog("Unable to accept the invitation, please try again","Error","OK");
      })
    }
    this.driverForm = new FormGroup({
      firstname: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      phone: new FormControl(null, [Validators.required, Validators.pattern(/^\d{10}$/)]),
      lastname: new FormControl(null, [Validators.required]),
    });
    this.licenseForm = new FormGroup({
      DRIVERS_LICENSE_FRONT: new FormControl(null, [Validators.required]),
      DRIVERS_LICENSE_BACK: new FormControl(null, [Validators.required]),
      licensenum: new FormControl(null, [Validators.required, Validators.pattern(/^\d{9}$/)]),
      license_exp: new FormControl(null, [Validators.required])
    });
    if (this.route.snapshot.queryParams.gSignUp) {
      this.gSignUp = true;
      this.driverForm.get('email').disable();
    }
    if (this.route.snapshot.queryParams.sub) {
      this.sub = this.route.snapshot.queryParams.sub;
    }
    if (this.route.snapshot.queryParams.firstname) {
      this.driverForm.patchValue({
        firstname: this.route.snapshot.queryParams.firstname
      })
    }
    if (this.route.snapshot.queryParams.lastname) {
      this.driverForm.patchValue({
        lastname: this.route.snapshot.queryParams.lastname
      })
    }
    if (this.route.snapshot.queryParams.email) {
      this.driverForm.patchValue({
        email: this.route.snapshot.queryParams.email
      })
    }
    this.passwordForm = this.formBuilder.group({
      terms:[false,Validators.required],
      password:[null,Validators.required],
      confirmpassword:[null,Validators.required],
      contractor: new FormControl(null, [Validators.required])
    });
    /*
    if (!this.gSignUp) {
      this.passwordForm.addControl('password', new FormControl(null, [Validators.required, Validators.minLength(8)]));
      this.passwordForm.addControl('confirmpassword', new FormControl(null, [Validators.required]));
    }*/
  }

  togglePassword() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  openTerms(){
    window.open( `${environment.SITE_URL}/terms-policy`, '_blank');
  }

  makePasswordNotRequired() {
    let password = this.driverForm.get('password');
    password.clearValidators();
    password.updateValueAndValidity();
    let confirm = this.driverForm.get('confirmpassword')
    confirm.clearValidators();
    confirm.updateValueAndValidity();
  }


  passwordMatch(){
    var passowrd = this.passwordForm.getRawValue().password;
    var confirmPassword = this.passwordForm.getRawValue().confirmpassword;
    if(confirmPassword == passowrd){
      return false;
    }else{
      return true;
    }
  }

  async checkEmailTaken() {
    if (this.driverForm.get('email').valid) {
      await this.driverService.emailExist(this.driverForm.getRawValue().email).then((taken) => {
        this.emailTaken = taken;
      }).catch(e => {

      });
    }
  }

  resetEmailTaken() {
    this.emailTaken = false;
  }

  onFrontSelected() {
    this.frontFile = this.front.nativeElement.files[0];
    if (this.frontFile) {
      let THIS = this;
      // Read and display the image preview
      const reader = new FileReader();
      reader.onload = e => this.frontPreview = reader.result;
      reader.readAsDataURL(this.frontFile);
    }
  }

  onBackSelected() {
    this.backFile = this.dBack.nativeElement.files[0];
    if (this.backFile) {
      let THIS = this;
      // Read and display the image preview
      const reader = new FileReader();
      reader.onload = e => this.backPreview = reader.result;
      reader.readAsDataURL(this.backFile);
    }
  }


  onEmploymentType(type) {
    this.passwordForm.patchValue({
      contractor: type
    });
  }

  openPicker() {
    this.picker.open();
  }

  async licenseStep() {
    FormUtils.markFormGroupTouched(this.driverForm);
    await this.checkEmailTaken();
    if (this.driverForm.valid && !this.emailTaken) {
      this.stepNum = 2;
    }
  }

  passwordStep() {
    FormUtils.markFormGroupTouched(this.driverForm);
    FormUtils.markFormGroupTouched(this.licenseForm);
    if (this.licenseForm.valid) {
      this.stepNum = 3;
    }
  }

  removeFront(event) {
    event.stopPropagation();
    this.front.nativeElement.value = null;
    this.frontFile;
    this.frontPreview = null;
    this.licenseForm.patchValue({
      DRIVERS_LICENSE_FRONT: null
    })
  }


  removeBack(event) {
    this.dBack.nativeElement.value = null;
    this.backFile;
    this.backPreview = null;
    this.licenseForm.patchValue({
      DRIVERS_LICENSE_BACK: null
    })
  }

  downloadApp() {
    window.open(`${ApplicationUrlSettings.NODE_API_URL}download-android`, "_blank");
  }

  back() {
    this.stepNum -= 1;
  }

  newDate(){
    alert('hello');
  }

  submit() {
    FormUtils.markFormGroupTouched(this.driverForm);
    //FormUtils.markFormGroupTouched(this.licenseForm);
    FormUtils.markFormGroupTouched(this.passwordForm);
    if (this.driverForm.valid && this.passwordForm.valid && this.passwordForm.get('terms').value && !this.passwordMatch()) {
      const formData = new FormData();
      let driver = this.driverForm.getRawValue();
      let license = this.licenseForm.getRawValue();
      let password = this.passwordForm.getRawValue();
      formData.append('firstname', driver.firstname);
      formData.append('lastname', driver.lastname);
      formData.append('email', driver.email);
      formData.append('clientid',this.clientid);
      formData.append('phone', driver.phone);
      //formData.append('licensenum', license.licensenum);
      //formData.append('license_exp', license.license_exp);
      if (this.sub) {
        formData.append('sub', this.sub);
      }
      formData.append('password', this.gSignUp ? null : password.password);
      formData.append('contractor', password.contractor);
      //formData.append('DRIVERS_LICENSE_FRONT', this.frontFile);
      //formData.append('DRIVERS_LICENSE_BACK', this.backFile);
      var payload = {
        access_string:this.access_string,
        firstname:driver.firstname,
        lastname:driver.lastname,
        email:driver.email,
        clientid:this.clientid,
        phone:driver.phone,
        sub:this.sub,
        password:this.gSignUp ? null : password.password,
        contractor:password.contractor
      };
      var d = new QuickDialog(this.dialog).LoadingDialog();
      this.driverService.registerDriver(payload).then(() => {
        d.close();
        this.router.navigate(['/driver-g-authorization-callback']);
      }).catch(e => {
        d.close();
        new QuickDialog(this.dialog).InfoDialog("Could not complete registration, please try again", "Registration Failed", "OK");
      })
    }else{
      new QuickDialog(this.dialog).InfoDialog("Please complete the form and click the checkbox to accept the privacy policy","Form Incomplete","OK");
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/driver-registration/driver-registration.component.ts